/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnqueuePreviewDto } from '../models/EnqueuePreviewDto';
import type { PreviewAdminJobDto } from '../models/PreviewAdminJobDto';
import type { PreviewOkDto } from '../models/PreviewOkDto';
import type { RoutePreviewManifestDto } from '../models/RoutePreviewManifestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminRoutePreviewsService {
  /**
   * @returns PreviewAdminJobDto
   * @throws ApiError
   */
  public static adminRoutePreviewsControllerGetJobs(): CancelablePromise<
    Array<PreviewAdminJobDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/route-previews/jobs',
    });
  }
  /**
   * @param requestBody
   * @returns PreviewAdminJobDto
   * @throws ApiError
   */
  public static adminRoutePreviewsControllerCreate(
    requestBody: EnqueuePreviewDto,
  ): CancelablePromise<PreviewAdminJobDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/route-previews/jobs',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns RoutePreviewManifestDto
   * @throws ApiError
   */
  public static adminRoutePreviewsControllerGetPreview(
    id: string,
  ): CancelablePromise<RoutePreviewManifestDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/route-previews/jobs/{id}/preview',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns PreviewOkDto
   * @throws ApiError
   */
  public static adminRoutePreviewsControllerApprove(id: string): CancelablePromise<PreviewOkDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/route-previews/jobs/{id}/publish',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns PreviewOkDto
   * @throws ApiError
   */
  public static adminRoutePreviewsControllerRepeat(id: string): CancelablePromise<PreviewOkDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/route-previews/jobs/{id}/retry',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns PreviewOkDto
   * @throws ApiError
   */
  public static adminRoutePreviewsControllerRemove(id: string): CancelablePromise<PreviewOkDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/route-previews/jobs/{id}/withdraw',
      path: {
        id: id,
      },
    });
  }
}
